export default "__VITE_ASSET__TK4Edbtd__"